
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSnowShowersDay as ObiSnowShowersDayElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-snow-showers-day.js';
 
 
 

 
 export const ObiSnowShowersDay = createComponent({
   react: React,
   tagName: 'obi-snow-showers-day',
   elementClass: ObiSnowShowersDayElement,
   events: {
     
   }
  });
 
 